export const GIFTING_OPEN_EVENT_TYPES = [
  'baby_shower',
  'baby_sprinkle',
  'babys_first',
  'bachelor',
  'bachelorette',
  'bridal_shower',
  'engagement',
  'gender_reveal',
  'post_wedding_brunch',
  'rehearsal_dinner',
  'save_the_date',
  'sip_and_see',
  'weddings',
  'welcome_reception',
];
